module.exports = __webpack_public_path__ + "img/frutos.be3dc0aa.png";